import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
import { Nav, NavDropdown} from 'react-bootstrap';


function NavArbitre(props) {
    const Navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const apiUrl = process.env.REACT_APP_API_URL;


    const toggleSidebar = () => {
      setSidebarOpen(!sidebarOpen);
    }

        const handleLogout = async (event) => {
            event.preventDefault();
            try {
                const response = await axios.post(`${apiUrl}/deconnexion`,
                    {},
                    {
                      withCredentials: true 
                    }
                  );
              if (response.data.success) {
                Cookies.remove(`token`)
                Navigate('/connexion'); 
              } else {
                console.error('Erreur lors de la déconnexion');
              }
            } catch (error) {
              console.error('Erreur lors de la déconnexion', error);
            }

          };

  return (
    <>
 <button className="toggle-button" onClick={toggleSidebar}>
        ☰
      </button>
      {sidebarOpen? ( 
      <div className='sidebar-container' >
        <div className="sidebar">
          <div className="sidebar-header" >
            <img src="/img/bel.png" alt="Logo" className="logo_" /> 
          </div>
          <Nav className="flex-column">
            <Nav.Link href="/arbitre/accueil">Accueil</Nav.Link>
            <Nav.Link href="/arbitre/parametre">Paramètres</Nav.Link>
            <Nav.Link href="/arbitre/agenda">Agenda</Nav.Link>
            <NavDropdown title="Tableau de bord" id="basic-nav-dropdown">
              <NavDropdown.Item href="/arbitre/tableau-de-bord">Accueil</NavDropdown.Item>
              <NavDropdown.Item href="/arbitre/tableau-de-bord/match">Match</NavDropdown.Item>
              <NavDropdown.Item href="/arbitre/tableau-de-bord/classement">Classement</NavDropdown.Item>
              <NavDropdown.Item href="/arbitre/tableau-de-bord/equipe/">Equipe</NavDropdown.Item>
              <NavDropdown.Item href="/arbitre/tableau-de-bord/arbitrage">Arbitrage</NavDropdown.Item>
          </NavDropdown>
            <Nav.Link href="/arbitre/post">Publications</Nav.Link>
            <Nav.Link href="/arbitre/messagerie">Messages</Nav.Link>
          </Nav>
          <div className="sidebar-footer">
            <div className="user-info">
              <div>{props.userData.user.donnée.results[0].nom} {props.userData.user.donnée.results[0].prenom}</div>
              <div className="nom club" style={{fontSize:"95%"}}>
                  <a href={`/arbitre/tableau-de-bord/equipe/arbitre/${props.userData.user.donnée.results[0].id}`}><span>Voir votre profil</span></a>
                </div>            </div>
            <button className="logout-button" onClick={handleLogout}>Déconnexion</button>
          </div>
        </div>
      </div>
          ):(<></>)}
    </>
  );
}

export default NavArbitre;
